// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"126":"6c44d60f","223":"commons","245":"component---src-pages-index-tsx","450":"react-apexcharts","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"126":"9258f5d8ffaf051265e9","223":"bc1058b54eaa1643c719","245":"5f83266d8f4d0533df7d","450":"0765d4d0e5eed0a53cdb","453":"26507cb569a333e8c6a4"}[chunkId] + ".js";
};